import { Badge } from '@mantine/core';

/** Shown next to FEATURE_VISIBILITY-gated page titles (not the app shell). */
export function LocalhostOnlyBadge(): JSX.Element {
  return (
    <Badge color="red" variant="filled" radius="xl" size="lg" tt="none">
      Localhost Only
    </Badge>
  );
}
